@let apps = ctrl.apps();
@let disabledVal = disabled();

<div
  #trigger
  [rtWalkthroughOriginStepId]="walkthroughId()"
  [rtWalkthroughOriginBeforeRender]="walkthroughBeforeRender()"
  [rtWalkthroughOriginAfterDispose]="walkthroughAfterDispose()"
  class="trigger"
  [class.disabled]="disabledVal"
  [class.active]="dropdown.open"
  rt-overlay-origin
  #dropdownTrigger="rtOverlayOrigin"
  (click)="!disabledVal ? dropdownOpenHandler($event, dropdown) : null"
  data-cy="app-switcher:trigger"
>
  <tlc-app-logo [brand]="brand" />

  @if (brand === TellentBrand.Tellent) {
    <rt-badge [text]="'tl.main_navigation.header_menu.admin_center' | translate" color="draft" />
  }

  @if (!disabledVal) {
    <rt-icon name="app-switcher-grid" />
  }
</div>

<ng-template
  #dropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  (backdropClick)="dropdown.open = false; dropdownOpenChange.emit(false)"
  [open]="dropdown.open"
  [origin]="dropdownTrigger"
>
  <tlc-app-switcher-dropdown [activeApp]="brand" [apps]="apps" />
</ng-template>
